/**
 * Shared GTM payload values - aligned with cellc_gtm_tracking_spec.csv
 */
export const GTM_CONSTANTS = {
  CUSTOMER_TYPE: 'Consumer',
  LINE_OF_BUSINESS: 'Fibre',
  DIGITAL_CHANNEL: 'Web',
  CURRENCY: 'ZAR',
  FEATURE_GROUPING_SALES: 'Sales and Onboarding',
  FEATURE_GROUPING_AUTH: 'Authentication and Profile',
  FEATURE_GROUPING_ACCOUNT_MANAGEMENT: 'Account Management',
  FIBRE_SALES_FUNNEL: 'Fibre Sales Funnel',
  FIBRE_JOURNEY: 'Fibre Journey',
  FIBRE_LEAD: 'Fibre Lead',
  /** Fallback dataLayer `plan_type` when the user has not picked one yet. Matches spec placeholder. */
  DATALAYER_PLAN_TYPE_DEFAULT: 'Postpaid/Prepaid',
  /** sessionStorage key for the currently-selected dataLayer `plan_type` (`Postpaid` | `Prepaid`). */
  PLAN_TYPE_SESSION_KEY: 'GtmPlanType',
} as const;

/** Concrete dataLayer `plan_type` values for emitted events. */
export type GtmDataLayerPlanType = 'Postpaid' | 'Prepaid';
